import "../../scss/components/_accordion.scss";

const accordionTargetHeaders = document.querySelectorAll('.js-accordion'),
    accordionCollapses = document.querySelectorAll('.accordion__collapse'),
    currentURLHash = window.location.hash;

const accordionSlideDown = (item, collapse) => {
    item.classList.add('accordion__item--active');

    collapse.style.height = 'auto';
    const collapseHeight = collapse.clientHeight + 'px';
    collapse.style.height = '0px';
    setTimeout(function () {
        collapse.style.height = collapseHeight;
    }, 0);
}

const accordionSlideUp = (item, collapse) => {
    const collapseHeight = collapse.clientHeight + 'px';
    collapse.style.height = collapseHeight;
    setTimeout(function () {
        collapse.style.height = '0px';
    }, 0);

    item.classList.remove('accordion__item--active');
}

for (const accordionTargetHeader of accordionTargetHeaders) {
    let accordionTargetElem = accordionTargetHeader.parentNode.closest('.accordion__item'),
        accordionTargetCol = accordionTargetElem.querySelector('.accordion__collapse'),
        accordionID = accordionTargetElem.id;
        
    if (currentURLHash) {
        if (accordionID !== null && accordionID !== '') {
            if( currentURLHash === '#' + accordionID )   {
                accordionSlideDown(accordionTargetElem, accordionTargetCol);
            }
        }
    }

    accordionTargetHeader.addEventListener('click', (e) => {
        const accordionTargetItem = e.target.parentNode.closest('.accordion__item'),
            accordionTargetCollapse = accordionTargetItem.querySelector('.accordion__collapse');

        if (accordionTargetItem.classList.contains('accordion__item--active')) {
            accordionSlideUp(accordionTargetItem, accordionTargetCollapse);
        } else {
            accordionSlideDown(accordionTargetItem, accordionTargetCollapse);
        }
    });
}
